<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">Impara a raccontare la tua storia.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Il corso di Digital Storytelling insegna a
    <span class="underline-a">organizzare contenuti per creare storie</span>
    tramite l’uso di tecnologie digitali. Spinge gli studenti a esercitare la
    comprensione del testo, le abilità di comunicazione e del linguaggio e la
    capacità di relazione.
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/people-pc.png"
        alt="people pc"
       
        class="people-pc"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">
    Organizzare elementi di vario formato in un unico racconto.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Cos’è il Digital Storytelling? È una strategia di comunicazione che consiste
    nell’organizzare contenuti in modo logico, che rispettino una determinata
    struttura narrativa, in formati compatibili con il web, in modo da ottenere
    un racconto costituito da molteplici elementi (video, audio, immagini,
    testi, mappe, ecc.). Imparare a padroneggiare tali procedure narrative
    significa anche
    <span class="underline-p">promuovere meglio valori e idee</span>.
  </p>
</div>

<div class="fifth container grid">
  <h3 class="w-700 blue-50 text-center">Affascinare il lettore.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Lo storytelling è <span class="underline-b">“l’arte del narrare”</span>,
    infatti il suo punto di forza consiste nell’affascinare il lettore
    attraverso i principi della retorica e della narratologia. In ambito
    didattico lo storytelling è fondamentale per rafforzare concetti e argomenti
    studiati in classe.
  </p>
</div>

<div class="sixth container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/tikitoki.png"
        alt="Interfaccia TikiToki"
       
        class="tt"
      />
      <p
        class="text-muted text-center text-xl-start ms-0 ms-xl-5 mt-3 tikitoki"
      >
        Esempio di creazione di una timeline con TikiToki
        <span class="d-none d-xl-inline-block">-</span>
        <a href="https://www.tiki-toki.com/" target="_blank" class="text-muted">
          www.tiki-toki.com</a
        >
      </p>
    </div>
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
